import gqlClient from '../gqlClient'

export function fetchNextModal() {
  return gqlClient.query(
    `query nextModal {
      nextModal {
        type
        payload
      }
    }
    `
  )
}

/**
 * @deprecated use markModalAsViewed instead
 */
export function markPromotionAwarenessModalAsViewed({ promotionId }) {
  return gqlClient.mutation(
    `mutation {
      markPromotionAwarenessModalAsViewed(promotionId: ${promotionId})
    }
    `
  )
}

export function markModalAsViewed({ type, payload = {} }) {
  return gqlClient.mutation(
    `mutation markAsViewed($type: String!, $payload: Any!) {
      markModalAsViewed(type: $type, payload: $payload)
    }
    `,
    {
      type,
      payload
    }
  )
}
